<template>
  <div class="container">
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
    />
    <div class="container-fluid h-custom">
      <div
        style="
          display: flex;
          justify-content: space-between;
          background-color: #f0f0f0;
          padding: 10px;
          border-radius: 5px;
        "
      >
        <h4 style="margin: 0; font-weight: bold; color: darkblue">
          Actualizar Clave
        </h4>
      </div>
      <hr />
      <div>
        <div>
          <br />
          <h5>
            Es importante que cambies tu clave regularmente para mantener la
            seguridad de tu cuenta. Nunca compartas tu clave con nadie.
          </h5>
          <br />
        </div>
      </div>
      <div class="d-flex" style="gap: 20px">
        <div class="flex-grow-1">
          <img
            src="../../assets/images/setPassword.png"
            class="img-fluid border-rounded"
            alt="Actualizar Clave"
          />
        </div>
        <div
          class="flex-grow-1 border-rounded"
          style="background-color: beige; padding: 50px"
        >
          <form @submit.prevent="updatePassword">
            <!-- Current Password input -->
            <div class="form-outline mb-4">
              <div class="input-group">
                <input
                  :type="currentPasswordVisible ? 'text' : 'password'"
                  id="currentPassword"
                  class="form-control form-control-lg"
                  v-model="currentPassword"
                  required
                />
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  @click="toggleCurrentPasswordVisibility"
                >
                  <span class="material-symbols-outlined">
                    {{
                      currentPasswordVisible ? "visibility" : "visibility_off"
                    }}
                  </span>
                </button>
              </div>
              <label class="form-label" for="currentPassword"
                >Clave Actual</label
              >
            </div>

            <!-- New Password input -->
            <div class="form-outline mb-4">
              <div class="input-group">
                <input
                  :type="newPasswordVisible ? 'text' : 'password'"
                  id="newPassword"
                  class="form-control form-control-lg"
                  v-model="newPassword"
                  required
                />
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  @click="toggleNewPasswordVisibility"
                >
                  <span class="material-symbols-outlined">
                    {{ newPasswordVisible ? "visibility" : "visibility_off" }}
                  </span>
                </button>
              </div>
              <label class="form-label" for="newPassword">Nueva Clave</label>
            </div>

            <!-- Confirm New Password input -->
            <div class="form-outline mb-4">
              <div class="input-group">
                <input
                  :type="confirmPasswordVisible ? 'text' : 'password'"
                  id="confirmPassword"
                  class="form-control form-control-lg"
                  v-model="confirmPassword"
                  required
                />
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  @click="toggleConfirmPasswordVisibility"
                >
                  <span class="material-symbols-outlined">
                    {{
                      confirmPasswordVisible ? "visibility" : "visibility_off"
                    }}
                  </span>
                </button>
              </div>
              <label class="form-label" for="confirmPassword"
                >Confirmar Nueva Clave</label
              >
            </div>

            <div class="text-center text-lg-start mt-4 pt-2">
              <button
                type="submit"
                class="btn btn-primary btn-lg"
                style="padding-left: 2.5rem; padding-right: 2.5rem"
              >
                Actualizar Clave
              </button>
              <p class="small fw-bold mt-2 pt-1 mb-0">
                <router-link to="/" class="link-danger"
                  >Regresar al inicio</router-link
                >
              </p>
            </div>

            <br />
            <br />
            <p v-if="message" class="mensaje">{{ message }}</p>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import swal from "sweetalert2";

export default {
  data() {
    return {
      p_idUsuario: 0,
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      message: "",
      currentPasswordVisible: false,
      newPasswordVisible: false,
      confirmPasswordVisible: false,
    };
  },
  mounted() {
    this.p_idUsuario = this.$route.params.p_idUsuario;
  },
  methods: {
    toggleCurrentPasswordVisibility() {
      this.currentPasswordVisible = !this.currentPasswordVisible;
    },
    toggleNewPasswordVisibility() {
      this.newPasswordVisible = !this.newPasswordVisible;
    },
    toggleConfirmPasswordVisibility() {
      this.confirmPasswordVisible = !this.confirmPasswordVisible;
    },
async updatePassword() {
  // Validaciones locales
  const validations = [
    { condition: !this.currentPassword, message: "Ingrese la contraseña actual" },
    { condition: !this.newPassword, message: "Ingrese la nueva contraseña" },
    { condition: !this.confirmPassword, message: "Ingrese la confirmación de la contraseña" },
    { condition: this.newPassword !== this.confirmPassword, message: "Las contraseñas no coinciden" }
  ];

  for (let v of validations) {
    if (v.condition) {
      this.message = v.message;
      return;
    }
  }

  try {
    const response = await api.post(`/actualizar-clave/${this.p_idUsuario}`, {
      claveActual: this.currentPassword,
      nuevaClave: this.newPassword,
    });

    // Éxito
    this.message = response.data.message || "Contraseña actualizada correctamente";
    this.currentPassword = "";
    this.newPassword = "";
    this.confirmPassword = "";

    await swal.fire({
      title: "¡Actualización Exitosa!",
      text: "Tu contraseña ha sido actualizada correctamente.",
      icon: "success",
      confirmButtonText: "Ok",
    });

    this.$router.push("/Login");
  } catch (error) {
    const backendMsg = error.response?.data?.error || "Error inesperado al actualizar la clave";
    this.message = backendMsg;

    swal.fire({
      title: "Error",
      text: backendMsg,
      icon: "error",
      confirmButtonText: "Ok",
    });
  }
},
  },
};
</script>

<style scoped>
.divider:after,
.divider:before {
  content: "";
  flex: 1;
  height: 1px;
  background: #eee;
}

.h-custom {
  height: calc(100% - 73px);
}

@media (max-width: 450px) {
  .h-custom {
    height: 100%;
  }
}
.border-rounded {
  border-radius: 20px;
}

.mensaje {
  color: red;
  font-weight: bold;
}

h4 {
  font-size: 1.5rem;
}

h5 {
  font-size: 1.25rem;
  color: darkred;
}
</style>
